import PropTypes from 'prop-types'

import {
  BreadcrumbAnchor,
  BreadcrumbArrow,
  BreadcrumbContainer,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbParent,
} from './Breadcrumb.styles'

function renderBreadcrumbItem(useAnchors) {
  return pathStep => {
    if (typeof pathStep == 'string') {
      return <BreadcrumbItem key={pathStep}>{pathStep}</BreadcrumbItem>
    }
    const { url, label } = pathStep
    if (url !== undefined) {
      return useAnchors ? (
        <BreadcrumbAnchor key={label} href={url}>
          <BreadcrumbItem>
            <BreadcrumbParent>{label}</BreadcrumbParent>
          </BreadcrumbItem>
        </BreadcrumbAnchor>
      ) : (
        <BreadcrumbLink key={label} to={url}>
          <BreadcrumbItem>
            <BreadcrumbParent>{label}</BreadcrumbParent>
          </BreadcrumbItem>
        </BreadcrumbLink>
      )
    } else {
      return <BreadcrumbItem key={label}>{label}</BreadcrumbItem>
    }
  }
}

function getBacktoUrl(path) {
  const pathWithUrl = path && path.slice(0, -1).filter(item => item.url !== undefined)
  return pathWithUrl[pathWithUrl.length - 1].url
}

function Breadcrumb(props) {
  const { path, useAnchors, backToURL } = props

  if (!path || path.length === 0) {
    return null
  }

  return (
    <BreadcrumbContainer>
      {useAnchors ? (
        <BreadcrumbAnchor href={backToURL || getBacktoUrl(path)}>
          <BreadcrumbArrow />
        </BreadcrumbAnchor>
      ) : (
        <BreadcrumbLink to={backToURL || getBacktoUrl(path)}>
          <BreadcrumbArrow />
        </BreadcrumbLink>
      )}
      {path.map(renderBreadcrumbItem(useAnchors))}
    </BreadcrumbContainer>
  )
}

Breadcrumb.propTypes = {
  path: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string,
    })
  ),
  useAnchors: PropTypes.bool,
  backToURL: PropTypes.string,
}

Breadcrumb.defaultProps = {
  path: [
    {
      label: '',
      url: undefined,
    },
  ],
  useAnchors: false,
  backToURL: null,
}

export { Breadcrumb }
